<template>
	<BaseCenteredMessage v-if="showSuccessMessage" hideLogoutButton>
		<template #title>Logging in...</template>
		<template #details> You can close this window or go to your workspace. </template>
		<template #actions>
			<button class="button-green" @click="closeWindow">Close window</button>
			<RouterLink to="/" class="flex mx-auto mt-20 link-white text-strong-base"> Go to my workspace </RouterLink>
		</template>
	</BaseCenteredMessage>
	<BaseCenteredPage v-else hideLogoutButton>
		<main class="w-full h-full flex flex-col justify-center items-center gap-8 text-gray-400">
			<BaseIcon name="mono/load" class="w-24 h-24" />
			<span>Loading...</span>
		</main>
	</BaseCenteredPage>
</template>

<script>
import {useTitle} from 'shared/composables/useTitle'
import messageExtension from 'shared/utils/messageExtension'

export default {
	name: 'AuthStartLogin',
	setup() {
		useTitle('Redirecting to login...')
	},
	data() {
		return {
			// the connection query param is used by the Auth0 `link-user-accounts` action, when redirecting login after linking accounts
			provider: this.$route.query.provider,
			showSuccessMessage: false,
		}
	},
	async mounted() {
		// This view is used by, auth/start-sso (named auth-browserstack-login), auth/legacy-login, auth/extension-login routes
		// auth/start-sso is the standard speedboat link for users coming from Browserstack
		// auth/legacy-login is for users who click on "Login with Bird" in the Browserstack login page

		// DEPRECATED since v1.99.0, kept for backward-compatibility - should be removed after < v1.99.0 is no longer seen in logs
		// auth/extension-login is for users who click on "Log in" in the extension
		// The extension attempts to set the auth session's `localStorage` value and reload, or triggers the login popup if that does not reauthenticate successfully.
		if (this.$auth.isAuthenticated.value && this.$route.name === 'auth-extension-login') {
			const localSessionReloaded = await messageExtension('reloadAfterLogin', {
				sessionId: this.$route.query.sessionId,
			})
			if (localSessionReloaded) window.close()
			this.showSuccessMessage = true
			return
		}
		// if logging in from the extension, we want to return here to be able to send messages to the extension that the user loggged in
		// as a rule, we always allow free trial when logging in from the extension, in case a user installed the extension before creating an account
		if (this.$route.name === 'auth-extension-login') {
			this.$auth.login({
				redirectUri: `${import.meta.env.VUE_APP_URL}${this.$route.fullPath}`,
				bugCaptureFreeTrial: true,
			})
			return
		}
		// end of DEPRECATED

		if (this.$route.name === 'auth-legacy-login') {
			// the connection query param is used by the Auth0 `link-user-accounts` action, when redirecting login after linking accounts
			// on normal usage, it will be undefined, redirecting to the universal login page
			await this.$auth.login({provider: this.provider || 'legacy'})
			return
		}

		const loginOptions = {}
		if (this.$route.query.ref) {
			loginOptions.utm_source = this.$route.query.ref
		}

		this.$auth.login(loginOptions)
	},
	methods: {
		closeWindow() {
			window.close()
		},
	},
}
</script>
